// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z-gs","type":"styles_type__lKmz4","choices":"styles_choices__PhcUv"};